import { createQueryString } from '~/domains/common/utils/queryString';
import type { PromoCarouselLocation, PromotionsResponse } from '~/domains/promotions/types';

import { promotionsService } from './promotions.instance';

export const getPromotions = async (location: PromoCarouselLocation) => {
  const params = { location };
  const queryParams = createQueryString((params ?? {}) as Parameters<typeof createQueryString>[0]);

  const response = await promotionsService.get<PromotionsResponse>(queryParams);

  return response.data;
};
